import React from 'react';
import { Container, Grid, Typography } from '@material-ui/core';
import { mainRoutes } from '../../routes';

import { ItemArea, Title } from './style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AdminManagement = ({ history }) => {
  return (
    <>
      <Container>
        <Title variant="h2">Painel Administrativo</Title>
        <Grid style={{ background: 'white', justifyContent: 'center' }} container spacing={2}>
          {mainRoutes.map(
            (i, index) =>
              i.isAdm &&
              i.label &&
              !i.show && (
                <ItemArea onClick={() => history.push(i.path)} key={index} item xs={2}>
                  <FontAwesomeIcon icon={i.icon} />
                  <Typography>{i.label}</Typography>
                </ItemArea>
              ),
          )}
        </Grid>
      </Container>
    </>
  );
};

export default AdminManagement;
